import React, { useEffect } from 'react';
import { EnquiryComponent } from '@vivli/features/enquiry/components';
import { EnquiryContextWrapper } from '@vivli/features/enquiry/infastructure/wrappers';
import { useEnquiryFormHook, useEnquiry } from '@vivli/features/enquiry/infastructure/hook';
import { FormProvider } from 'react-hook-form';

export const EnquiryFeature = () => {
    const { enquiry, setEnquiry } = useEnquiry();
    const formApi = useEnquiryFormHook(enquiry);

    useEffect(() => {
        if (!enquiry) return;

        formApi.reset(enquiry, { keepErrors: true, keepIsValid: true });
        formApi.trigger();
    }, [enquiry]);

    return (
        <FormProvider {...formApi}>
            <EnquiryContextWrapper enquiry={enquiry} setEnquiry={setEnquiry}>
                <EnquiryComponent />
            </EnquiryContextWrapper>
        </FormProvider>
    );
};
